import React, { Fragment } from "react";
import { Link } from "react-router-dom";

// UI Components
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-regular-svg-icons";

// Custom components
import { readablePhoneNumber } from "../../../utils/normalize";

export default ({ onUserAction }) => [
  {
    dataField: "firstname_vch",
    text: "Name",
    sort: true,
    isDummyField: true,
    formatter: (cell, approver) => `${approver.firstname_vch} ${approver.lastname_vch}`,
  },
  {
    dataField: "email_vch",
    text: "Email",
    sort: true,
  },
  {
    dataField: "sms_number_vch",
    text: "Text",
    sort: true,
    formatter: readablePhoneNumber,
  },
  // {
  //   dataField: "phone_number_vch",
  //   text: "Voice",
  //   sort: true,
  //   formatter: formatPhoneNumber,
  // },
  {
    dataField: "action",
    text: "Actions",
    isDummyField: true,
    headerStyle: () => ({ width: "100px" }),
    formatter: (cell, approver) => (
      <Fragment>
        <Link to="#" onClick={() => onUserAction("edit", approver)}>
          <FontAwesomeIcon icon={faEdit} size="lg" color="primary" className="mr-3" />
        </Link>
        <Link to="#" onClick={() => onUserAction("delete", approver)}>
          <FontAwesomeIcon icon={faTrashAlt} size="lg" color="red" />
        </Link>
      </Fragment>
    ),
  },
];
